module.exports = "/_next/static/fonts/NewSpiritCondensed-SemiBold-8ca144e1478173f59b5d5f53e3c989f2.woff2";